import PropTypes from 'prop-types';
import React from 'react';

import FormInputError from '../Form/FormInputError';
import OrdinaryOfferingAmountInput from '../Form/OfferingAmount/OrdinaryOfferingAmountInput';
import PredefinedOfferingAmountRadio from '../Form/OfferingAmount/PredefinedOfferingAmountRadio';
import ServiceFee from '../ServiceFee/ServiceFee';

const DonationAmount = ({
  allowFreeOfferings,
  clearErrors,
  donationAmount,
  errors,
  isServiceFeeCoveredRequired,
  isServiceFeeEnabled,
  massOfferingAmount,
  name,
  serviceFeeLoading,
  setDonationAmount,
  setError,
  setUserCoversServiceFee,
  totalAmountToPay,
  userCoversServiceFee,
}) => {
  const registerUserCoversServiceFeeInput = fieldName => {
    return {
      onChange: e => {
        setUserCoversServiceFee(e.target.checked);
      },
      name: fieldName,
      checked: !!userCoversServiceFee,
    };
  };

  const amountElement =
    (massOfferingAmount?.predefinedValues?.length ?? 0) <= 1 ? (
      <OrdinaryOfferingAmountInput
        allowFreeOfferings={allowFreeOfferings}
        minimalValue={massOfferingAmount.minimalValue}
        onChange={setDonationAmount}
        name={name}
      />
    ) : (
      <PredefinedOfferingAmountRadio
        allowFreeOfferings={allowFreeOfferings}
        massOfferingAmount={massOfferingAmount}
        minimalMassOfferingAmount={massOfferingAmount.minimalValue}
        onChange={setDonationAmount}
        setError={setError}
        clearErrors={clearErrors}
        name={name}
        optionalFreeOfferingsMessage=""
        value={donationAmount}
      />
    );

  return (
    <div>
      <input
        className="form-control"
        id="transaction_form_amount"
        inputMode="decimal"
        name="transaction_form[amount]"
        pattern="[0-9]+([.,][0-9]{0,2})?"
        required="required"
        step="0.1"
        type="hidden"
        min="1"
        value={totalAmountToPay}
      />
      <div>
        {amountElement}

        {errors['transaction-donation-amount'] && (
          <FormInputError errorText={errors['transaction-donation-amount'].message} />
        )}
      </div>

      {isServiceFeeEnabled && (
        <div className="mb-5 mt-3">
          <input
            type="hidden"
            name="service_fee_covered"
            value={userCoversServiceFee ? '1' : '0'}
          />

          <ServiceFee
            inputFieldName="userCoversServiceFee"
            isRequired={isServiceFeeCoveredRequired}
            register={registerUserCoversServiceFeeInput}
            totalAmountToPay={totalAmountToPay}
            offeringAmount={donationAmount}
            serviceFeeLoading={serviceFeeLoading}
          />
        </div>
      )}
    </div>
  );
};

DonationAmount.propTypes = {
  allowFreeOfferings: PropTypes.bool,
  isServiceFeeCoveredRequired: PropTypes.bool,
  massOfferingAmount: PropTypes.shape({
    predefinedValues: PropTypes.array,
    allowOwnAmount: PropTypes.bool,
    minimalValue: PropTypes.number,
  }).isRequired,
  name: PropTypes.string,
  setError: PropTypes.func,
  clearErrors: PropTypes.func,
  errors: PropTypes.array,
  serviceFeeLoading: PropTypes.bool,
  donationAmount: PropTypes.number,
  setDonationAmount: PropTypes.func,
  setUserCoversServiceFee: PropTypes.func,
  totalAmountToPay: PropTypes.number,
  userCoversServiceFee: PropTypes.bool,
  isServiceFeeEnabled: PropTypes.bool,
};

export default DonationAmount;
